import type { ICustomSegment } from "app/services/segments/segmentsApiService";
import type { ITrafficDataResult } from "app/services/segments/segmentsWizardServiceTypes";

export const resolveTrackingCustomAttributes = (segment: ICustomSegment, trafficDataResult: ITrafficDataResult) => {
    const { SegmentShare: segmentShare, SegmentVisits: visits, SiteVisits: siteVisits } = trafficDataResult;
    const customAttributes = {
        ...resolveTrackingCustomAttributesBase(segment),
        Site_Visits: siteVisits,
        Segment_Share: segmentShare,
        Segment_Visits: visits,
    };
    return customAttributes;
};

export const resolveTrackingCustomAttributesBase = (segment: ICustomSegment) => {
    const { id, segmentName, domain } = segment;
    const customAttributes = {
        Segment_ID: id,
        Segment_Name: segmentName,
        Segment_Domain: domain,
    };
    return customAttributes;
};
